import * as tslib_1 from "tslib";
import { updateUserOptions } from 'owa-options-core';
import { getCalendarConfiguration, saveCalendarMailboxConfiguration, updateCalendarMailboxConfiguration, } from 'owa-calendar-configuration';
import updateSurfaceOptions from '../data/actions/updateSurfaceOptions';
import { logDataOnSaveWeekStartDayQuickSetting } from '../utils/logDataOnSaveAppearance';
/**
 *  Called when we update week start day option from quick settings panel.
 *  Updates user options so that the changes are reflected in current user session
 *  Updates the calendar configuration on local store and on server
 */
function saveWeekStartDayQuickSetting(dayOfWeek) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var calendarConfiguration, WeekStartDay;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    calendarConfiguration = getCalendarConfiguration();
                    WeekStartDay = dayOfWeek;
                    updateUserOptions({ WeekStartDay: WeekStartDay });
                    updateCalendarMailboxConfiguration({ WeekStartDay: WeekStartDay });
                    /**
                     * Action dispatched to call an orchestrator in owa-calendar which will initialize surface options.
                     */
                    updateSurfaceOptions();
                    return [4 /*yield*/, saveCalendarMailboxConfiguration(calendarConfiguration)];
                case 1:
                    _a.sent();
                    logDataOnSaveWeekStartDayQuickSetting();
                    return [2 /*return*/];
            }
        });
    });
}
export default saveWeekStartDayQuickSetting;
//# sourceMappingURL=saveWeekStartDayQuickSetting.js.map